import SchoolImage from "../../../../../assets/images/png/school/international/white-woman.webp";

export const programmingSchoolDataEurope = {
  tag: "Programming",
  id: "programmingSchool",
  url: "/programming-school",
  image: SchoolImage,

  name: "Programming school",
  description: `
  Go from zero knowledge to being able to build your own complete website! Starting with the foundations of software engineering. By the end of this program you would have mastered a specialization and learn the art of effective collaboration to solve real world problems.`,
  keywords: `Programming, programming school, coding, software engineer, software developer`,
  metatags: `Are you looking to learn programming or coding in Nigeria? Start your career in programming with courses from Utiva Programming School. Get the technical skills to get the job you want`,

  courses: [],

  testimony: {
    testimonierImage: "",
    testimonierName: "",
    testimonierTitle: "",
    testimonyDescription: ``,
  },

  article: [],

  careerTitle: "Computer Programmer",

  careerPaths: [
    "Web Developer",
    "Front-End Developer",
    "Back-End Developer",
    "Full-Stack Developer ",
    "Game Developer",
    "Software Application Developer ",
    "Computer Systems Engineer ",
  ],

  quickFactSalary: "$85,000",

  quickFacts: [
    "Programming and coding has been identified as one of the skills for the future of work, according to a 2021 report by the World Economic Forum. computer programming and software engineering is one of the most high-profile jobs in the tech industry today. Companies are looking for software engineering talent - whether that's as a graduate or as a senior hire. ",
  ],
};
